import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createKareNote } from './createKareNote';
import { createCcrcModal } from './createCcrcModal';
import { createHsptlzFormSlice } from './createHsptlzFormSlice';
import { createMedicalReceiptSlice } from './createMedicalReceiptSlice';
import { createPersonalInfoAgree } from './createPersonalInfoAgree';

export const useBoundStore = create(
  immer((...a) => ({
    personalInfoAgree: { ...createPersonalInfoAgree(...a) },
    ccrcModal: { ...createCcrcModal(...a) },
    hsptlzForm: { ...createHsptlzFormSlice(...a) },
    medicalReceipt: { ...createMedicalReceiptSlice(...a) },
    kareNote: { ...createKareNote(...a) },
  })),
);

